import { CodeItemCodesAccess } from 'app/area/codetable/item/types';
import { AccessCodetables, CodetableMetadata } from './types-store';

export const ACTION = {
  REQUEST_METADATA: 'CODETABLE_ADMINISTRATION:REQUEST_METADATA',
  RECEIVE_METADATA: 'CODETABLE_ADMINISTRATION:RECEIVE_METADATA',
  FAIL_METADATA: 'CODETABLE_ADMINISTRATION:FAIL_METADATA',
  REQUEST_ACCESS_CODETABLES: 'CODETABLE_ADMINISTRATION:REQUEST_ACCESS_CODETABLES',
  RECEIVE_ACCESS_CODETABLES: 'CODETABLE_ADMINISTRATION:RECEIVE_ACCESS_CODETABLES',
  FAIL_ACCESS_CODETABLES: 'CODETABLE_ADMINISTRATION:FAIL_ACCESS_CODETABLES',
  REQUEST_CODE_ITEM_ACCESS_CODES: 'CODETABLE_ADMINISTRATION:REQUEST_CODE_ITEM_ACCESS_CODES',
  RECEIVE_CODE_ITEM_ACCESS_CODES: 'CODETABLE_ADMINISTRATION:RECEIVE_CODE_ITEM_ACCESS_CODES',
  FAIL_CODE_ITEM_ACCESS_CODES: 'CODETABLE_ADMINISTRATION:FAIL_CODE_ITEM_ACCESS_CODES',
  CLEAR_CODETABLES_ACCESS: 'CODETABLE_ADMINISTRATION:CLEAR_CODETABLES_ACCESS', 
  CLEAR_CODES_ACCESS: 'CODETABLE_ADMINISTRATION:CLEAR_CODES_ACCESS'
};

export class RequestMetadata {
  public type: string = ACTION.REQUEST_METADATA;
  constructor(public id: number) {
  }
}

export class ReceiveMetadata {
  public type: string = ACTION.RECEIVE_METADATA;
  constructor(public id: number, public metadata: CodetableMetadata) {
  }
}

export class FailMetadata {
  public type: string = ACTION.FAIL_METADATA;
  constructor(public id: number) {
  }
}

export class RequestAccessCodetables {
  public type: string = ACTION.REQUEST_ACCESS_CODETABLES;
  constructor(public id: number) {
  }
}

export class ReceiveAccessCodetables {
  public type: string = ACTION.RECEIVE_ACCESS_CODETABLES;
  constructor(public id: number, public accessCodetables: AccessCodetables) {
  }
}

export class FailAccessCodetables {
  public type: string = ACTION.FAIL_ACCESS_CODETABLES;
  constructor(public id: number) {
  }
}

export class RequestCodeItemAccessCodes {
  public type: string = ACTION.REQUEST_CODE_ITEM_ACCESS_CODES;
  constructor(public codetableId: number, public codeId: number) {
  }
}

export class ReceiveCodeItemAccessCodes {
  public type: string = ACTION.RECEIVE_CODE_ITEM_ACCESS_CODES;
  constructor(public accessCodes: CodeItemCodesAccess) {
  }
}

export class FailCodeItemAccessCodes {
  public type: string = ACTION.FAIL_CODE_ITEM_ACCESS_CODES;
  constructor(public codetableId: number, public codeId: number) {
  }
}

export class ClearCodesAccess {
  public type: string = ACTION.CLEAR_CODES_ACCESS;
}

export class ClearCodetablesAccess {
  public type: string = ACTION.CLEAR_CODETABLES_ACCESS;
}
